// extracted by mini-css-extract-plugin
export default {"overlay":"AuthLoadingScreen_overlay__R5NIl","logo":"AuthLoadingScreen_logo__PtmWr","spinner":"AuthLoadingScreen_spinner__rMVIU","spin":"AuthLoadingScreen_spin__RAL25"};